(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accordion"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const accordionItems = document.querySelectorAll('.accordion-item');
  
  // Set "Le Ricette di Mamie" to be open initially
  const firstAccordionItem = accordionItems[0];
  const firstContent = firstAccordionItem.querySelector('.accordion-content');
  const firstIcon = firstAccordionItem.querySelector('.accordion-icon');
  
  firstAccordionItem.classList.add('active');
  firstContent.style.maxHeight = firstContent.scrollHeight + 30 + 'px';
  firstContent.style.paddingTop = '1rem';
  firstContent.style.paddingBottom = '0';
  firstIcon.style.transform = 'rotate(180deg)';
  
  accordionItems.forEach(item => {
    const header = item.querySelector('.accordion-header');
    const content = item.querySelector('.accordion-content');
    const icon = item.querySelector('.accordion-icon');
    
    header.addEventListener('click', () => {
      const isActive = item.classList.contains('active');
      
      // Close all accordion items
      accordionItems.forEach(otherItem => {
        otherItem.classList.remove('active');
        const otherContent = otherItem.querySelector('.accordion-content');
        const otherIcon = otherItem.querySelector('.accordion-icon');
        
        otherContent.style.maxHeight = '0';
        otherContent.style.paddingTop = '0';
        otherContent.style.paddingBottom = '0';
        otherIcon.style.transform = 'rotate(0deg)';
      });
      
      // Open clicked item if it wasn't active
      if (!isActive) {
        item.classList.add('active');
        content.style.maxHeight = content.scrollHeight + 30 + 'px';
        content.style.paddingTop = '1rem';
        content.style.paddingBottom = '0';
        icon.style.transform = 'rotate(180deg)';
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collections-list"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
